<template>
  <div class="f-c-c-c container">
    <a :href="PDAApkUrl" download="warehouse.apk">Download Warehouse App</a>
  </div>
</template>
<script>
import { PDAApkUrl } from '@/api/stock'
export default {
  name: 'PDADownload',
  data() {
    return {
      PDAApkUrl
    }
  },
  methods: {
    async download() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.container {
  height: 100%;
}
</style>
